import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VSelect, {
    attrs: {
      "value": _vm.editedWidget.chartOptions.type,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.type.label'),
      "items": _vm.chartTypes,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.type', $event);
      }
    }
  })], 1)], 1), _c('widget-chart-toolbox-editor', {
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  }), _vm.editedWidget.chartOptions.type !== 'custom' ? _c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.labelFormat'),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.labelFormat.label'),
      "persistent-hint": "",
      "hint": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.labelFormat.hint'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.labelFormat', $event);
      }
    }
  })], 1), _vm.editedWidget.chartOptions.type !== 'gauge' ? _c(VCol, [_c(VTextField, {
    attrs: {
      "value": _vm.getByKey('chartOptions.dateTimeFormat'),
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.dateTimeFormat.label'),
      "persistent-hint": "",
      "hint": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.dateTimeFormat.hint'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.setByKey('chartOptions.dateTimeFormat', $event);
      }
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c(VSwitch, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetChartOptionsEditor.inputs.legend.show.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.showLegend,
      callback: function ($$v) {
        _vm.showLegend = $$v;
      },
      expression: "showLegend"
    }
  })], 1)], 1) : _vm._e(), _vm.editedWidget.chartOptions.type === 'gauge' ? _c('gauge-chart-options-editor', {
    attrs: {
      "custom-parameters": _vm.customParameters,
      "dashboard-id": _vm.dashboardId
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  }) : _vm._e(), _vm.editedWidget.chartOptions.type === 'custom' ? _c('chart-custom-options-editor', {
    on: {
      "open-code-editor": function ($event) {
        return _vm.$emit('open-code-editor');
      }
    },
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  }) : _vm._e(), ['line', 'bar'].includes(_vm.editedWidget.chartOptions.type) ? _c('line-bar-chart-options-editor', {
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  }) : _vm._e(), _vm.editedWidget.chartOptions.type === 'heatmap' ? _c('heatmap-chart-options-editor', {
    model: {
      value: _vm.editedWidget,
      callback: function ($$v) {
        _vm.editedWidget = $$v;
      },
      expression: "editedWidget"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };